<template>
    <div class="fixed z-10 inset-0 overflow-y-auto">
      <div class="flex items-center py-8 justify-center min-h-screen">
        <div class="fixed inset-0 transition-opacity">
          <div class="absolute inset-0 bg-black opacity-50"></div>
        </div>
        <div
          class="bg-white rounded-lg overflow-hidden shadow-xl px-6 py-6 z-50 min-w-[90vw] md:min-w-[40vw]"
        >
          <div class="flex justify-between items-center mb-6">
            <h2 class="text-xl font-medium text-gray-800 dark:text-white">
              Configuración de correos
            </h2>
            <button
              @click="isActive"
              class="text-gray-500 hover:text-gray-700 w-8 h-8 flex items-center justify-center hover:bg-gray-200 rounded-lg"
            >
              <svg class="w-5 h-5">
                <use href="../../../assets/svg/icon.svg#cancel" />
              </svg>
            </button>
          </div>
          <form class="w-full space-y-6" @submit.prevent>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Sucursales
              </span>
              <Stores @send-data="getSelectStore" />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
              Correo electrónico
              </span>
              <input
                type="email"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500"
                v-model="dataForm.description"
                placeholder="Correo electrónico..."
                @keydown.enter.prevent
                maxlength="30"
              />
            </label>
  
            <div class="flex mt-[3.5rem!important] lg:mt-[2rem!important]">
              <button
                class="bg-blue-500 text-white px-4 py-2 font-semibold text-sm rounded-lg hover:shadow-sm hover:shadow-blue-600 active:scale-95 flex items-center"
                @click="insert"
                :disabled="spinner === true"
              >
                <div class="flex items-center" v-if="spinner">
                  <svg class="w-4 h-4 mr-3 animate-spin">
                    <use href="../../../assets/svg/icon.svg#spinnerForBlue" />
                  </svg>
                  Registrando Información
                </div>
                <span v-else>Registrar</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { ref } from "vue";
  import { confirmationOfRecord, errorActions } from "@/alerts";
  import { observer } from "@/observer";
  import axios from "../../../api";
  import Stores from "@/components/PublicComponents/Stores.vue";
  
  export default {
    name: "RegisterEmails",
    props: {
      activeModal: {
        type: Function,
        required: true,
      },
      getdata: {
        type: Function,
        required: true,
      },
    },
    components:{
      Stores
    },
    setup(props) {
      function isActive() {
        props.activeModal(true);
      }
  
      const spinner = ref(false); // Sirve para mostrar un loading al momento de enviar información
  
      const dataForm = ref({
        idStore: 0,
        description: "",
      });
  
      //recepcion de datos desde el componente publico, todas la sucursales
      const getSelectStore = (data) => {
        dataForm.value.idStore = data;
      };
  
      const insert = async () => {
        if (dataForm.value.idStore <= 0) {
          errorActions("Por favor selecciona una <strong>sucursal</strong>");
          observer.observe(
            document.querySelector(".swal2-container"),
            { box: "content-box" },
            10
          );
          return;
        }
        if (!validateEmail(dataForm.value.description)) {
          errorActions("Ingresa un <strong>correo</strong> válido, de preferencia el correo que más usas");
          observer.observe(
            document.querySelector(".swal2-container"),
            { box: "content-box" },
            10
          );
          return;
        }
        if (dataForm.value.description <= 2) {
          errorActions("Ingresa un <strong>correo</strong> válido, de preferencia el correo que más usas");
          observer.observe(
            document.querySelector(".swal2-container"),
            { box: "content-box" },
            10
          );
          return;
        }
        spinner.value = true;
        const response = await axios
          .post(
            "correos",
            {
              idStore: dataForm.value.idStore,
              description: dataForm.value.description,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .catch(function (error) {
            errorActions(error);
          });
        const data = await response.data;
        if (data.msg === true) {
          confirmationOfRecord(
            `El correo  <strong>${dataForm.value.description}</strong>`
          );
          props.getdata();
          dataForm.value.description = "";
        } else if (data.msg === "Request failed with status code 500") {
          errorActions("Request failed with status code 500");
        } else if (data.msg === 'exist') {
          errorActions(
            `Ya existe un  <strong>correo</strong> con la misma descripción a la que estas intentando registrar`
          );
        } else {
          errorActions(
            `Lo sentimos, no pudimos registrar el correo <strong>${dataForm.value.description}</strong>`
          );
        }
        
        spinner.value = false; //dejando activo al boton
        observer.observe(
          document.querySelector(".swal2-container"),
          { box: "content-box" },
          10
        );
      };
      //funcion para validar un email ( @, . )
    const validateEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };
      return {
        isActive,
        dataForm,
        insert,
        spinner,
        getSelectStore,
        Stores
      };
    },
  };
  </script>
  